/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import Dialog from "../../../../../../components/Dialog/Dialog";
import { useMediaQueries } from "../../../../../../shared";
import RectangleLoader from "../../../../../../shared/components/loaders/RectangleLoader";
import CloseDialogButton from "../../components/CloseDialogButton";
import NewsDialogTextContent from "../../components/NewsDialogTextContent";
import NewsImageContainer from "../../components/NewsImageContainer";
import { NewsDto } from "../../types";
import { NEWS_DIALOG_SIZES } from "../../types/enums";

interface SingleNewsDialogProps {
  newsData: NewsDto | null;
  isOpen: boolean;
  onClose: () => void;
  isLoading: boolean;
  title: string;
}

const SingleNewsDialog = ({
  newsData,
  isOpen,
  onClose,
  isLoading,
  title
}: SingleNewsDialogProps) => {
  const { toMd } = useMediaQueries();

  return (
    <Dialog
      data-testid="single-news-dialog"
      wordBreakTitle="break-word"
      isTitleSeparator
      title={title}
      isActionsSeparator
      actions={<CloseDialogButton onClose={onClose} isLoading={isLoading} />}
      open={isOpen}
      close={onClose}
      width={NEWS_DIALOG_SIZES.width}
      extendToMaxWidth={toMd}
    >
      <div
        css={css({
          maxWidth: "100%",
          flex: "1",
          gap: "16px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          paddingBottom: "16px",

          ...(!toMd && { height: "365px" })
        })}
      >
        <div
          css={css({
            maxWidth: "200px",
            height: "132px",
            flexShrink: 0
          })}
        >
          <NewsImageContainer
            image={newsData?.imageName || undefined}
            isLoading={isLoading}
          />
        </div>

        <div
          css={css({
            flex: 1,
            minWidth: 0,
            marginRight: "8px"
          })}
        >
          {isLoading ? (
            <RectangleLoader
              testId="news-content-loader"
              width="100%"
              height={
                toMd
                  ? NEWS_DIALOG_SIZES.dialogTextContentLoaderHeightToMd
                  : NEWS_DIALOG_SIZES.dialogContentLoaderHeight
              }
              customStyle={{ marginBottom: "16px" }}
            />
          ) : (
            <NewsDialogTextContent newsData={newsData} toMd={toMd} />
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default SingleNewsDialog;
